"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookQueryDto = exports.LookDto = void 0;
const canDto_1 = require("./canDto");
const folderDto_1 = require("./folderDto");
const queryDto_1 = require("./queryDto");
const reportDto_1 = require("./reportDto");
class LookModelDto {
    constructor(dto) {
        this.id = parseInt(dto.id);
        this.label = dto.label;
    }
}
class LookDto extends reportDto_1.ReportDto {
    constructor(lookDto, lastViewedAt) {
        super(lookDto.id, lookDto.title, lookDto.description, new folderDto_1.FolderDto(lookDto.folder), new canDto_1.CanDto(lookDto.can), lookDto.content_metadata_id, lookDto.content_favorite_id, lookDto.user_id, lookDto.created_at, lookDto.deleted_at, lookDto.favorite_count, lookDto.viewCount, lastViewedAt);
        this.model = lookDto.model;
    }
    static get QUERY_FIELDS() {
        return `${reportDto_1.ReportDto.QUERY_FIELDS},model`;
    }
}
exports.LookDto = LookDto;
class LookQueryDto {
    constructor(lookQueryDto) {
        this.id = parseInt(lookQueryDto.id);
        this.query = lookQueryDto.query;
    }
    static get QUERY_FIELDS() {
        return `id,query(${queryDto_1.QueryDto.QUERY_FIELDS})`;
    }
}
exports.LookQueryDto = LookQueryDto;
